/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GranularPnoEntries } from './GranularPnoEntries';
import {
    GranularPnoEntriesFromJSON,
    GranularPnoEntriesFromJSONTyped,
    GranularPnoEntriesToJSON,
    GranularPnoEntriesToJSONTyped,
} from './GranularPnoEntries';
import type { PnoEntry } from './PnoEntry';
import {
    PnoEntryFromJSON,
    PnoEntryFromJSONTyped,
    PnoEntryToJSON,
    PnoEntryToJSONTyped,
} from './PnoEntry';

/**
 * 
 * @export
 * @interface ShopPerformancePno
 */
export interface ShopPerformancePno {
    /**
     * 
     * @type {Array<PnoEntry>}
     * @memberof ShopPerformancePno
     */
    pnoTotalByCurrency?: Array<PnoEntry>;
    /**
     * GranularPnoEntries>
     * @type {{ [key: string]: GranularPnoEntries; }}
     * @memberof ShopPerformancePno
     */
    pnoGranularByCurrency?: { [key: string]: GranularPnoEntries; };
}

/**
 * Check if a given object implements the ShopPerformancePno interface.
 */
export function instanceOfShopPerformancePno(value: object): value is ShopPerformancePno {
    return true;
}

export function ShopPerformancePnoFromJSON(json: any): ShopPerformancePno {
    return ShopPerformancePnoFromJSONTyped(json, false);
}

export function ShopPerformancePnoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopPerformancePno {
    if (json == null) {
        return json;
    }
    return {
        
        'pnoTotalByCurrency': json['pnoTotalByCurrency'] == null ? undefined : ((json['pnoTotalByCurrency'] as Array<any>).map(PnoEntryFromJSON)),
        'pnoGranularByCurrency': json['pnoGranularByCurrency'] == null ? undefined : (mapValues(json['pnoGranularByCurrency'], GranularPnoEntriesFromJSON)),
    };
}

export function ShopPerformancePnoToJSON(json: any): ShopPerformancePno {
    return ShopPerformancePnoToJSONTyped(json, false);
}

export function ShopPerformancePnoToJSONTyped(value?: ShopPerformancePno | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pnoTotalByCurrency': value['pnoTotalByCurrency'] == null ? undefined : ((value['pnoTotalByCurrency'] as Array<any>).map(PnoEntryToJSON)),
        'pnoGranularByCurrency': value['pnoGranularByCurrency'] == null ? undefined : (mapValues(value['pnoGranularByCurrency'], GranularPnoEntriesToJSON)),
    };
}

